import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import { formatearFecha } from '../../helpers/helper'
import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import styles from './MensajeriaNew.module.css'

export const Mensaje = ({ mensaje, usuario, tipoMensajes, manejarAdjunto }) => {
  const {
    idMensaje,
    texto,
    fechaEscrito,
    textoRta,
    fechaEscritoRta,
    idUsuarioChat,
    idAdjunto
  } = mensaje
  const [adjunto, setAdjunto] = useState(null)
  const [imagenAmpliada, setImagenAmpliada] = useState(null)

  const fetchAdjunto = async (id) => {
    const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(id)
    await manejarAdjunto(data, setAdjunto)
  }

  useEffect(() => {
    if (!adjunto && idAdjunto) {
      fetchAdjunto(idAdjunto)
    }
  }, [idAdjunto])

  const obtenerClaseAlineado = (idUsuarioChat) =>
    usuario === idUsuarioChat && tipoMensajes === 'chat'
      ? styles.mensaje
      : styles.mensajeMio

  return (
    <div key={idMensaje}>
      {imagenAmpliada && (
        <div className={styles.overlay} onClick={() => setImagenAmpliada(null)}>
          <img alt="Imagen ampliada" src={imagenAmpliada} className={styles.overlayImg} />
        </div>
      )}
      <p className={obtenerClaseAlineado(idUsuarioChat)}>
        {texto}

        {adjunto && (
          <div className={styles.archivoWrapper}>
            {adjunto.contentType.startsWith('image/') ? (
              <img
                src={adjunto.url}
                alt={adjunto.nombre}
                className={styles.imgAdjunto}
                onClick={() => setImagenAmpliada(adjunto.url)}
              />
            ) : adjunto.contentType === 'application/pdf' ? (
              <a
                href={adjunto.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.archivoItem}
              >
                <i className="fa fa-file-pdf-o" />
                <span>{adjunto.nombre}</span>
              </a>
            ) : (
              <a
                href={adjunto.url}
                download={adjunto.nombre}
                className={styles.archivoItem}
              >
                <i className="fa fa-file-o" />
                <span>{adjunto.nombre}</span>
              </a>
            )}
          </div>
        )}

        <span className={styles.fechaMensaje}>
          {formatearFecha(fechaEscrito, 'FH', 'hs')}
        </span>
      </p>

      {textoRta && (
        <div className="ms-4 text-secondary position-relative">
          <div className={styles.respuestaFlecha}></div>
          <p className={styles.textoMensaje}>
            {textoRta}
            <span className={styles.fechaMensaje}>
              {formatearFecha(fechaEscritoRta, 'FH', 'hs')}
            </span>
          </p>
        </div>
      )}

      {tipoMensajes === 'preguntas' && <hr />}
    </div>
  )
}

Mensaje.propTypes = {
  mensaje: PropTypes.shape({
    idMensaje: PropTypes.number.isRequired,
    texto: PropTypes.string.isRequired,
    fechaEscrito: PropTypes.string.isRequired,
    textoRta: PropTypes.string,
    fechaEscritoRta: PropTypes.string,
    idUsuarioChat: PropTypes.number.isRequired,
    idAdjunto: PropTypes.number
  }).isRequired,
  usuario: PropTypes.string.isRequired,
  tipoMensajes: PropTypes.string.isRequired,
  manejarAdjunto: PropTypes.func.isRequired
}
